import { BotData, GroupData, MarketplaceSubGroup } from "@shared/types";

export type ConnectGroupButtonData = {
  buttonText: string;
  onClick: () => void;
  onContinue?: () => Promise<any>;
  onClose?: () => void;
  loading?: boolean;
  disabled?: boolean;
  link?: string;
  addIcon?: boolean;
  modalTitle?: string;
  modalContent?: string;
  continueSuccessMessage?: string;
};

export enum JoinGroupButtonType {
  SUBSCRIBE = "group_info.buttons.subscribe",
  START_FREE_TRIAL = "group_info.buttons.start_free_trial",
  JOIN_GROUP = "group_info.buttons.join_group",
  ACTIVE_FREE_TRIAL = "group_info.buttons.active_free_trial",
  JOINED = "group_info.buttons.joined",
}

export interface ConnectGroupProps {
  content?: string;
  isChecked?: boolean;
  setIsChecked: (isChecked: boolean) => void;
  showError?: boolean;
  isHighRisk?: boolean;
}

export interface ConnectGroupModalProps {
  visible: boolean;
  closeModal: () => void;
  groupData?: GroupData;
  modalData: ConnectGroupButtonData;
  isHighRisk?: boolean;
}

export enum ConnectGroupModalSteps {
  CONNECT_GROUP,
  AUTO_TRADING,
}

export interface SignalsBotOverviewProps {
  groupData?: GroupData;
  onFinishOnboarding?: (botData?: BotData) => void;
  subscribeGroup?: () => Promise<void> | undefined;
  skipText: string;
  onSkipClick: () => void;
  getConfirmMessage: () => string;
}

export enum ScoreSection {
  PERFORMANCE = "Performance",
  RISK = "Risk",
  SERVICE = "Service",
}

export enum GroupsSort {
  SCORE = "sort.score",
  NAME = "sort.name",
  RATING = "sort.rating",
  PRICE = "sort.price",
  SIX_MONTH_PNL = "sort.six_month_pnl",
  THREE_MONTH_PNL = "sort.three_month_pnl",
  ONE_MONTH_PNL = "sort.one_month_pnl",
  RISK = "sort.risk",
}

export enum RiskType {
  LOW = "risk_type.low",
  MEDIUM = "risk_type.medium",
  HIGH = "risk_type.high",
  VERY_HIGH = "risk_type.very_high",
}

export interface GroupMainInfoProps {
  isOnboarding?: boolean;
  image: string;
  name: string;
  stars?: number | null;
  numReviewers?: number;
  numSubscribers?: number;
  scoreTagProps?: {
    score?: number;
    onClick?: () => void;
    isTopTrader?: boolean;
  };
  groupId?: number;
  hideCreateButton?: boolean;
  groupData?: GroupData | MarketplaceSubGroup;
  isMyGroups?: boolean;
}
